<template>
  <div class="scroll-view">
    <slot></slot>
    <div class="loading" v-if="isLoading">
      <img class="loading-icon" src="@/assets/loading.png" alt="">
      <span class="loading-text">加载更多内容...</span>
    </div>
    <div class="end" v-else-if="isEnd">
      <img class="end-icon" src="@/assets/orz-tv.png" alt="">
      <span class="end-text">已经到底啦_(:з”∠)_</span>
    </div>
    <div class="bottom" ref="bottomRef"></div>
  </div>
</template>

<script>
import 'intersection-observer'

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isEnd: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !this.isLoading && !this.isEnd) {
        this.$emit('reach-bottom')
      }
    })
    this.io.observe(this.$refs.bottomRef)
  },
  beforeDestroy () {
    this.io && this.io.disconnect()
  }
}
</script>

<style lang="less" scoped>
.loading {
  height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  .loading-icon {
    width: 22px;
    height: 22px;
    animation: loading-icon-keyframes 0.8s infinite linear;
  }
  .loading-text {
    margin-left: 9px;
    color: #999999;
    font-size: 14px;
    font-weight: 400;
  }
}
.end {
  height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  .end-icon {
    width: 71px;
    height: 20px;
  }
  .end-text {
    margin-left: 9px;
    color: #999999;
    font-size: 14px;
    font-weight: 400;
  }
}
.bottom {
  width: 1px;
  height: 1px;
}

@keyframes loading-icon-keyframes {
  100% {
    transform: rotate(360deg);
  }
}
</style>
